export enum ModalAction {
  UNSAVED_CHANGES = 'UNSAVED_CHANGES',
  NEW_PROJECT = 'NEW_PROJECT',
}

export type ModalState = {
  action: ModalAction;
  payload?: {
    projectId?: number;
  };
};
